import { PickListItem, JsonItem, RevamppVirus } from "../list-management.objects"; 
import { SpecialCaseEntity } from "../list-management.form-sections";
import _ from "lodash";

export class PathogenFocusSelctor implements SpecialCaseEntity {
    id: string;
    propertyName: string;
    pickListName: string;
    familyPickListName: string;

    isRequired: boolean;
    displayName: string;
    showVirusFamilyBtn: boolean;

    pathogenList: RevamppVirus[];
    familyList: PickListItem[];
    pathogenTable: any;
    initialPathogens: RevamppVirus[];
    addedPathogens: RevamppVirus[];
    searchedPathogen: RevamppVirus;

    constructor(id: string, propteryName: string, pathogenListName: string, additionalPickLists: string[], displayName: string, isRequired: boolean, showVirusFamilyBtn: boolean = true) {
        this.id = id;
        this.propertyName = propteryName;
        this.pickListName = pathogenListName;
        this.familyPickListName = additionalPickLists.find(pl => pl.includes("family"));
        this.addedPathogens = [];
        this.initialPathogens = [];
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.showVirusFamilyBtn = showVirusFamilyBtn;
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";

        let virusFamilyBtn = "";
        let virusFamilyText = ``;
        if (this.showVirusFamilyBtn) {
            virusFamilyBtn = `
                <div class="pl-3 col-auto mb-3 align-self-end">
                    <a class="btn btn-small revampp-blue-btn text-decoration-none add-family-btn" id="add-pathogen-family-btn-${this.id}" style="width: 160px">+ Add Family</a>
                </div>
            `

            virusFamilyText = `<p class='form-text mb-1 mt-0'>Adding a Virus Family will add <b>ALL</b> of the viruses in the family to the Virus list.</p>`
        }

        let html = `
            <div><label for="" class="${requiredClass}">${this.displayName}</label></div>
            <div class="pathogen-focus-selection-block mb-4">
                <div class="search-section-block py-2">
                    <div class="row px-3 py-2 align-items-center">
                        <div class="col-10 col-md-6 d-flex">
                            <select id="pathogen-search-${this.id}" class="selectpicker dropdown list-management-dropdown" title="Search Viruses" data-width="100%" data-live-search="true" data-container="body" data-size="5">
                                
                            </select>
                            <div class="reset-pathogen-search">
                                <a id="reset-pathogen-search-btn-${this.id}" class="btn btn-secondary reset-pathogen-search-btn font-size14">
                                    <i class="fa-solid fa-xmark"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-auto pl-1">
                            <i class="fa-solid fa-magnifying-glass white-icon"></i>
                        </div>
                    </div>
                </div>
                <div class="add-pathogen-focus-block py-3">
                    <div class="row px-3">
                        <div class="col-md-6 col-12 pathogen-block-form">
                            <div class="row mb-2">
                                <div class="form-group col">
                                    <label>Virus Family:</label> 
                                    ${virusFamilyText}
                                    <select class="selectpicker dropdown list-management-dropdown" id="pathogen-family-select-${this.id}" title="-- Select a Virus Family --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                                ${virusFamilyBtn}
                            </div>

                            <div class="row">
                                <div class="form-group col">
                                    <label>Virus Name:</label>
                                    <p class='form-text mb-1 mt-0'>Adding a Virus will the individual virus to the Virus list.</p>
                                    <select class="selectpicker dropdown list-management-dropdown" id="pathogen-name-select-${this.id}" title="-- Select a Virus Name --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                                <div class="pl-3 col-auto mb-3 align-self-end">
                                    <a class="btn btn-small revampp-blue-btn text-decoration-none add-pathogen-btn" id="add-pathogen-btn-${this.id}" style="width: 160px">+ Add Virus</a>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12 pathogen-block-table mt-md-0 mt-3">
                            <div>
                                <div class="revampp-datatable">
                                    <table id="pathogen-focus-table-${this.id}" class="table table-striped">
                                        
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            `
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        // Create PathogenList
        this.pathogenList = [];
        this.familyList = [];

        let foundPathogenList = pickLists.find(list => list.Id == this.pickListName);
        let foundFamilyList = pickLists.find(list => list.Id == this.familyPickListName);

        if (!foundPathogenList || !foundFamilyList) return;

        this.pathogenList = foundPathogenList.Json;
        this.familyList = foundFamilyList.Json;

        // Search Box for Pathogens
        let pathogenSearchArr: string[][] = [];
        this.pathogenList.forEach(pathogen => {
            pathogenSearchArr.push([pathogen.VirusName, pathogen.Id.toString()]);
        })
        this.generateDropdown(`pathogen-search-${this.id}`, pathogenSearchArr);

        // Dropdown for Families + Pathogens
        let familyArr: string[][] = [];
        this.familyList.forEach(family => familyArr.push([family.Value, family.Id.toString()]));
        this.generateDropdown(`pathogen-family-select-${this.id}`, familyArr);
        this.generateDropdown(`pathogen-name-select-${this.id}`, []);

        //initialize table
        this.initializePathogenTable();

        // initialize Search functionality
        this.initializeSearchTool();
    }

    getValue(): any {
        let pathogenIdArr = this.addedPathogens.map(pathogen => pathogen.Id);
        return pathogenIdArr.join("|");
    }

    validate(): boolean {
        return true;
    }

    getDisplayFamily(familyId: number): string {
        let returnVal = ""
        let foundFamily = this.familyList.find(family => family.Id == familyId);
        if (foundFamily) {
            returnVal = foundFamily.Value;
        }
        return returnVal;
    }

    updateStoredValues(entityArray: any[]): void {
        // This isn't going to work for mulitple items;
        if (entityArray.length <= 0) return;
        let targetEntity = entityArray[0];
        let pathogenIds: string = _.get(targetEntity, this.propertyName);
        let pathogenArr: RevamppVirus[] = [];
        let pathogenIdArr: string[] = pathogenIds.split("|");
        pathogenIdArr.forEach(pathogenId => {
            let foundPathogen = this.pathogenList.find(pathogen => pathogen.Id.toString() == pathogenId);
            if (foundPathogen) {
                pathogenArr.push(foundPathogen);
            }
        })

        this.initialPathogens = pathogenArr;
        this.addedPathogens = pathogenArr;
        this.updatePathogenTable();
    }

    checkChanged(): boolean {
        //return _.isEqual(this.initialPathogens, this.addedPathogens);
        return true;
    }

    initializePathogenTable(): void {
        let table = $(`#pathogen-focus-table-${this.id}`).DataTable({
            "dom": '<"top-controls"<"count-section"><"search-section"<"search-bar"f>>>rtip',
            autoWidth: false,
            info: false,
            paging: true,
            pageLength: 8,
            search: true,
            scrollX: false,
            orderCellsTop: true,
            columns: [
                { data: "VirusName", title: "Name", className: "text-left font-size12" },
                { data: "FamilyId", title: "Family", className: "text-left font-size12", render: (data, type) => { return this.getDisplayFamily(data) } },
                { title: "", className: "text-center delete-pathogen-btn", defaultContent: `<a><i class="fa-solid fa-trash"></i></a>` },
            ],
            language: {
                emptyTable: 'No Added Viruses',
                search: ""
            },
            data: this.pathogenList

        });
        this.pathogenTable = table;

        $(".top-controls").addClass('row justify-content-between align-items-center');

        let tableBlock = $(`#pathogen-focus-table-${this.id}`).closest(".pathogen-block-table");
        $(tableBlock).find(".count-section").addClass("col-6").html(`<label style="font-size: 14px;">Added Viruses: <span class="added-pathogens-count"></span></label>`)
        $(tableBlock).find(".search-section").addClass('col-6');
        $(tableBlock).find(".search-bar").addClass('d-flex justify-content-end vertical-align-top align-content-start');

        //on delete pathogen button click
        $(`#pathogen-focus-table-${this.id} tbody`).on('click', '.delete-pathogen-btn', (event) => {
            // Get Item from Row
            var tr = $(event.currentTarget).closest('tr');
            var row = this.pathogenTable.row(tr);
            let data: RevamppVirus = row.data();

            // Find Index in Added Pathogens
            let foundIndex = this.addedPathogens.findIndex(pathogen => pathogen.Id == data.Id);
            if (foundIndex >= 0) {
                this.addedPathogens.splice(foundIndex, 1);

                // Update Table
                this.updatePathogenTable();
            }
        });

        this.setAddedPathogenCountLabel(this.addedPathogens.length);
    }

    updatePathogenTable(): void {
        this.pathogenTable.clear();
        this.pathogenTable.rows.add(this.addedPathogens);
        this.pathogenTable.draw();

        this.setAddedPathogenCountLabel(this.addedPathogens.length);
    }

    setAddedPathogenCountLabel(count: number): void {
        let tableBlock = $(`#pathogen-focus-table-${this.id}`).closest(".pathogen-block-table");
        $(tableBlock).find(".added-pathogens-count").text(count);
    }

    initializeSearchTool(): void {
        // Search for Pathogen
        $(`#pathogen-search-${this.id}`).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            // Get Searched Pathogen (Id)
            let searchedPathogen = $(`#pathogen-search-${this.id}`).val();

            let foundPathogen = this.pathogenList.find(pathogen => pathogen.Id.toString() == searchedPathogen);
            this.searchedPathogen = foundPathogen;
            if (foundPathogen != undefined) {
                // Set Pathogen Family Dropdown
                let foundFamily = this.familyList.find(family => family.Id == foundPathogen.FamilyId);
                if (foundFamily != undefined) {
                    $(`#pathogen-family-select-${this.id}`).val(foundFamily.Id.toString()).trigger("change");
                }
            }
            else {
                // No Pathogen Selected, Reset Family
                $(`#pathogen-family-select-${this.id}`).val("");
                $(`#pathogen-family-select-${this.id}`).selectpicker("refresh").trigger("change");
            }
        });

        // Change Pathogen Family
        $(`#pathogen-family-select-${this.id}`).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            // Get Selected Family
            let searchedFamily = $(`#pathogen-family-select-${this.id}`).val();

            // Clear existing options
            $(`#pathogen-name-select-${this.id}`).empty();

            // Create Dropdown options for Pathogen Name
            let foundFamily = this.familyList.find(family => family.Id.toString() == searchedFamily.toString());
            if (foundFamily != undefined) {

                let foundPathogens = this.pathogenList.filter(pathogen => pathogen.FamilyId == foundFamily.Id);
                foundPathogens.sort((x1, x2) => x1.VirusName.localeCompare(x2.VirusName));

                foundPathogens.forEach(pathogen => {
                    $(`#pathogen-name-select-${this.id}`).append(`<option value="${pathogen.Id}">${pathogen.VirusName}</option>`)
                });

                $(`#add-pathogen-family-btn-${this.id}`).removeClass("disabled");
            }
            else {
                $(`#add-pathogen-family-btn-${this.id}`).addClass("disabled");
            }

            $(`#pathogen-name-select-${this.id}`).selectpicker("refresh")
            // If there is a searched pathogen, set it as the value in Pathogen Name
            if (this.searchedPathogen != null) {
                $(`#pathogen-name-select-${this.id}`).val(this.searchedPathogen.Id.toString());
                this.searchedPathogen = null;
            }
            $(`#pathogen-name-select-${this.id}`).trigger("change");
        });

        // Change Pathogen Name
        $(`#pathogen-name-select-${this.id}`).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {

            // Get Selected Pathogen
            let searchedPathogen = $(`#pathogen-name-select-${this.id}`).val();

            // Create Dropdown options for Pathogen Name
            let foundPathogen = this.pathogenList.find(pathogen => pathogen.Id.toString() == searchedPathogen);
            if (foundPathogen != undefined) {
                $(`#add-pathogen-btn-${this.id}`).removeClass("disabled");
            }
            else {
                $(`#add-pathogen-btn-${this.id}`).addClass("disabled");
            }
        });

        $(`#reset-pathogen-search-btn-${this.id}`).on('click', () => {
            $(`#pathogen-search-${this.id}`).val("").trigger("change");
            $(`#add-pathogen-family-btn-${this.id}`).addClass("disabled");
            $(`#add-pathogen-btn-${this.id}`).addClass("disabled");
        });

        $(`#add-pathogen-family-btn-${this.id}`).on('click', () => {
            // Get Family
            let searchedFamily = $(`#pathogen-family-select-${this.id}`).val();
            let foundFamily = this.familyList.find(family => family.Id.toString() == searchedFamily);
            if (foundFamily == undefined) return;

            // Get Pathogens in Family
            let foundPathogens = this.pathogenList.filter(pathogen => pathogen.FamilyId == foundFamily.Id);
            foundPathogens.sort((x1, x2) => x1.VirusName.localeCompare(x2.VirusName));

            // Add Pathogens to List of Added Pathogens (no duplicates)
            foundPathogens.forEach(foundPathogen => {
                if (this.addedPathogens.find(pathogen => pathogen.Id == foundPathogen.Id) == undefined) {
                    this.addedPathogens.push(foundPathogen);
                }
            });

            // Update Added Pathogens Table
            this.updatePathogenTable();
        });

        $(`#add-pathogen-btn-${this.id}`).on('click', () => {
            // Get Pathogen
            let searchedPathogen = $(`#pathogen-name-select-${this.id}`).val();
            let foundPathogen = this.pathogenList.find(pathogen => pathogen.Id.toString() == searchedPathogen);
            if (foundPathogen == undefined) return;

            // Add Pathogen to List of Added Pathogens (no duplicates)
            if (this.addedPathogens.find(pathogen => pathogen.Id == foundPathogen.Id) == undefined) {
                this.addedPathogens.push(foundPathogen);
            }

            // Update Added Pathogens Table
            this.updatePathogenTable();
        })
    }

    generateDropdown(dropdownId: string, options: string[][]): void {
        // Remove any previous options
        $(`#${dropdownId}`).find("option").remove();

        $(`#${dropdownId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });
        if (options != undefined) {
            options.sort((x1: string[], x2: string[]) => {
                if (x1[0].startsWith("-") && !x2[0].startsWith("-")) {
                    return 1;
                }
                else if (x2[0].startsWith("-") && !x1[0].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[0].localeCompare(x2[0]);
                }
            });
            options.forEach((element: string[]) => {
                $(`#${dropdownId}`).append(new Option(element[0], element[1], false, false))
            })
        }

        $(`#${dropdownId}`).selectpicker("refresh");
    }

    getDisplayValue(indexVal = -1): string {
        return "";
    }
}